import {debounce, breakpoint} from '../utils/utilities.js';
var $ = jQuery;

function init() {
  /**
   * Constructor function
   * @param {Object} $context jquery object
   */
  function BuildNav($context) {
    var self = this;

    //selectors
    self.$stickyNav = $context.find('.article__sticky-nav');
    self.$leftRef = $context.find('div.article__left-ref');
    self.$chapters = $context.find('.article__sticky-nav-nav-wrapper').find('button');
    self.$chapterHeading = $context.find('.article__chapter-heading');
    self.$articleBody = $context.find('.article__body-copy');
    self.$articleNavToggle = $context.find('.article__sticky-nav-toggle');
    self.$article = $context;
    self.$readMore = $context.find('.article-body__read-more');
    self.$chapterCount = $context.find('.article__sticky-nav-current');

    self.chapterVars = {
      chapterInd: 0,
      left: 0,
      right: 0,
      positions: [],
      breakpoint: ''
    };

    resetTOC();
    binds();
    // $(this.$article).off('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', initNav);
    this.$stickyNav.addClass('_visible');

    function resetTOC() {
      self.$stickyNav.removeClass('_open');
      getPositions();
      stickyNav();
      setChapter();
    }

    function binds() {

      $(window).on('chapterChange', toggleHighlight);

      $(window).on('scroll', stickyNav);
      $(window).on('scroll', debounce(function() {
        setChapter();
      }, 250));

      $(window).on('resize', debounce(function() {
        resetTOC();
      }, 250));

      $(window).on('recalculateChapeters', resetTOC);

      self.$chapters.on('click', scrollToChapter);

      self.$articleNavToggle.on('click', function() {
        self.$stickyNav.toggleClass('_open');
      });
    }

    /**
     * Get Positions for sticky Nav
     */
    function getPositions() {
      self.chapterVars.positions = [];
      self.chapterVars.breakpoint = breakpoint();
      self.chapterVars.offset = getOffset();

      for(let i = 0; i < self.$chapterHeading.length; i ++) {
        if(i === 0) {
          self.chapterVars.positions.push($(self.$chapterHeading[i]).offset().top - $(self.$chapterHeading[i]).outerHeight());
        }
        else {
          self.chapterVars.positions.push($(self.$chapterHeading[i]).offset().top - $(self.$chapterHeading[i]).outerHeight() - self.chapterVars.offset);
        }
      }

      self.chapterVars.chapterHeight = self.$stickyNav.outerHeight(true) + 60;

      if(self.chapterVars.breakpoint === 'desktop') {
        self.chapterVars.positions.push(($(self.$articleBody).offset().top + $(self.$articleBody).outerHeight(true)) - self.chapterVars.chapterHeight);
        self.chapterVars.left = getHorizontalPosition();
      }
      else {
        self.chapterVars.positions.push(($(self.$articleBody).offset().top + $(self.$articleBody).outerHeight(true)) - $(window).height() - ($(self.$articleNavToggle).outerHeight(true)*2));
      }
    }

    /**
     * Get offset for sticky nav
     * @return {Number} Offset
     */
    function getOffset() {
      let vHeight = window.innerHeight;
      return vHeight/3;
    }

    /**
     * Get Horizontal position for nav
     * @return {Number} Horizontal Position
     */
    function getHorizontalPosition() {
      return (self.$leftRef.offset().left - $(window).scrollLeft());
    }

    /**
     * Initialize Sticky Nav
     */
    function stickyNav() {
      let currentPosition = $(window).scrollTop();
      let positions = self.chapterVars.positions;

      if(currentPosition > positions[0] && currentPosition < positions[positions.length -1]) {
        if(!self.$stickyNav.hasClass('_active')) {
          self.$stickyNav.removeClass('_bottom');
          self.$stickyNav.addClass('_active');
        }
        self.$stickyNav.attr('style', '');
        if(self.chapterVars.breakpoint === 'desktop') {
          $(self.$stickyNav).css({'left' : self.chapterVars.left, 'top' : 0});
        }

      }
      else if(currentPosition > positions[positions.length -1]) {
        if(!self.$stickyNav.hasClass('_bottom')) {
          unfixSticky();
        }
      }
      else {
        self.$stickyNav.removeClass('_active');
        if(self.chapterVars.breakpoint === 'desktop') {
          $(self.$stickyNav).css({
            'left' : '0',
            'top' :  +  Number($(self.$chapterHeading[0]).position().top) + 'px'
          });
        }
      }
    }

    /**
     * Unfix sticky Nav
     */
    function unfixSticky() {
      if(self.chapterVars.breakpoint === 'desktop') {
        if(!self.$stickyNav.hasClass('_bottom')) {
          $(self.$stickyNav).css({
            'top': (self.$articleBody.outerHeight(true) - self.chapterVars.chapterHeight) +'px',
            'left': '0',
            'right': 'initial'
          }).removeClass('_active').addClass('_bottom');
        }
      }
      else {
        if(!self.$stickyNav.hasClass('_bottom')) {
          $(self.$stickyNav).css({
            'top': (self.$articleBody.outerHeight(true) - self.chapterVars.chapterHeight) +'px',
            'right': '0',
            'left': 'initial'
          }).removeClass('_active').addClass('_bottom');
        }
      }
    }


    /**
     * Set Chapeter in sticky Nav
     */
    function setChapter() {
      let currentPosition = $(window).scrollTop();
      let positions = self.chapterVars.positions;

      for(var i = 0; i < positions.length; i ++) {
        let next = positions[i+1];

        if(((currentPosition >= positions[i]) && (currentPosition <= next)) || currentPosition < positions[0]) {
          self.chapterVars.chapterInd = next === undefined ? 0 : i;
          $(window).trigger('chapterChange');
        }
        else if(currentPosition > positions[positions.length -1]) {
          if(self.chapterVars.chapterInd !== positions.length -2) {
            self.chapterVars.chapterInd = (positions.length -2);
            toggleHighlight();
          }
        }
      }
    }

    /**
     * Toggles chapter Highlight
     */
    function toggleHighlight() {
      let chapterIndex = self.chapterVars.chapterInd === undefined ? 0 : self.chapterVars.chapterInd;
      self.$chapters.removeClass('_active');
      $(self.$chapters[chapterIndex]).addClass('_active');
      self.$chapterCount.html(chapterIndex + 1);
    }

    function scrollToChapter(e) {
      let ind = self.$chapters.index($(e.target));
      if(self.chapterVars.breakpoint !== 'desktop') {
        self.$stickyNav.removeClass('_open');
      }

      $('html, body').animate({
        scrollTop: ($(self.$chapterHeading[ind]).offset().top + 5) +'px'
      }, 1000);
    }

  }

  $(document).on('click', '.article-body__read-more', function(e) {
    //let $this = $(this);
    //let $btns = $('.article-body__read-more');
    //let ind = $btns.index($this);
    //let $body = $('.article__sticky-track')[ind];
    //$($body).on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', initNav);
    initNav($(this));
  });


  function initNav($this) {
    let $articleContext = $($this).prev('.article__sticky-track');

    if(!$(this).hasClass('_inactive')) {
      if($articleContext.find('.article__chapter-heading').length > 0) {
        new BuildNav($articleContext);
      }
      $(window).trigger('recalculateChapeters');
    }
  }
}

export { init as init };
